import Vue from 'vue'
import Router from 'vue-router'
import indexpage from '@/components/index'
import indexlist from '@/components/indexlist.vue'
import api from '../utils/api.js'
//招商大脑（各版本通用）的链接 
import tagsearch from '@/components/common-list/tagsearch.vue' //标签搜索页 
import targetEnterprise from '@/components/common-list/targetEnterprise.vue' //标签搜索页 
import opportunities from '@/components/common-list/wholeChainlist.vue' //产业机会(全国图谱) 
import concernedEn from '@/components/common-list/concernedEn.vue' //龙头企业 (产业链招商线索) 23.12.4废置，已由recommendation 替换
import recommendation from '@/components/common-list/recommendation.vue' //新版智能能推荐（关注领域相关企业）
import investmentInstitutions from '@/components/common-list/investmentInstitutions.vue' //投资机构
import innovativeResources from '@/components/common-list/innovativeResources.vue' //创新资源（研究院
import enterpriseDetail from '@/components/detail/enterpriseDetail.vue' //内资企业详情页 
import enterpriseDetailFree from '@/components/detail/enterpriseDetail-free.vue' //免费用户的内资企业详情页  
import enterpriseDetailF from '@/components/detail/enterpriseDetailF.vue' //境外上市企业详情页 foreign
import inresourcesDetail from '@/components/detail/inresourcesDetail.vue' //研究院详情页
import institutionDetail from '@/components/detail/jigouDetail.vue' //投资机构详情页
import chaindetailpage from '@/components/detail/chaindetail.vue' //产业链详情页(全国图谱)
import localChaindetail from '@/components/detail/localChaindetail.vue' //产业链详情页(全国图谱)
import newsdetail from '@/components/detail/newsDetail.vue' //宏观背景 
import enterpriseSurroundMap from '@/components/mapsearch/enterpriseSurroundMap.vue' //某个企业周边企业地图 
import localInvestAnalysis from '@/components/common-list/localInvestAnalysis.vue' //本地投资趋势列表 
import investAnalysisEnterpirseDetail from '@/components/detail/investAnalysisEnterpirseDetail.vue' //本地投资趋势详情 
import foreignInvestment from "@/components/common-list/foreignInvestment.vue" //外商投资分析
import freeTips from "@/components/common-list/freeTips.vue" //免费用户提示
import orders from "@/components/common-list/orders.vue" //订单
import payType from "@/components/common-list/payType.vue" //支付方式
import paySuccess from "@/components/common-list/paySuccess.vue" //支付成功
import wxPay from "@/components/common-list/wxPay.vue" //微信支付
import aiChat from "@/components/common-list/ai.vue" //微信支付

import homePage from "@/components/home-page/homePage.vue" //招商大脑首页


import videoCourses from '@/components/common-list/video-courses.vue' //视频课程链接 
import industrialpark from "@/components/common-list/industrialpark.vue" //产业园区
import focusenterprises from "@/components/common-list/focusenterprises.vue" //关注企业


import policyCompareTable from '@/components/common-list/policy-compare/index-table.vue' //政策对比的首页 表格版
import enterpriseCompareTable from '@/components/enterprise-compare/index-table.vue' //对比企业的首页 表格版
import enterpriseCompareRecords from '@/components/enterprise-compare/record.vue' //对比企业的对比记录
import leftnav from '@/components/inc/leftnav.vue' //左侧菜单栏
// import header from '@/components/inc/header.vue' //头部导航栏  
import enterpriseList from "@/components/common-list/enterpriseList.vue" //龙头上市优质创新企业集合列表
import forcapEnterprise from "@/components/common-list/forcapEnterprise.vue" //外资企业列表
import ForeignEnterprises from "@/components/common-list/ForeignEnterprises.vue" //境外上市企业列表
import totalenterprises from "@/components/common-list/totalEnterprises.vue" //全部内资企业-
import totalSearch from "@/components/common-list/totalSearch.vue" //全部内资企业-
// import chainEnterprise from "@/components/common-list/chainEnterprise-11.vue" //产业链概念下的企业
import localChainList from "@/components/common-list/localChainList.vue" //当地图谱
import urbanBigDataList from "@/components/common-list/urbanBigDataList.vue" //当地图谱
import urbanBigData from "@/components/detail/urbanBigData.vue" //当地图谱
import chainEnterpriselist from "@/components/detail/chainEnterpriseDetail.vue" //产业链概念下的企业的更多企业
import allchain from '@/components/common-list/allchain.vue' //产业链首页（所有产业链 ）
import localChainMoreEnterprise from '@/components/common-list/localChainMoreEnterprise.vue' //当地图谱跳转更多企业
import generateCharts from '@/components/common-list/generateCharts.vue' //当地图谱跳转更多企业
import chartDetail from '@/components/detail/chartDetail.vue' //



//园区专用
import allBuildings from '@/components/park/allBuildings.vue' //产业链首页（所有产业链 ） 
import allenterprise from '@/components/park/allEnterprises.vue' //当地图谱跳转更多企业
import buildingdetail from '@/components/park/buildingDetail.vue' //当地图谱跳转更多企业
import enterpriseYq from '@/components/park/enterpriseDetail-yq.vue' //当地图谱跳转更多企业 
import parkFocusEnterprises from "@/components/park/park-foucsEnterprise.vue" //关注企业

//招商大脑简易版链接

import cityInvestTrend from '@/components/simple/invest-project-trend.vue' //简易版上市企业在本市投资-集合版省市外市
// import cityInvestProject from '@/components/simple/city-invest-project.vue' //简易版上市企业在本市投资
// import cityLandProject from '@/components/simple/city-land-project.vue' //简易版企业在本市拿地投资
// import provinceInvestProject from '@/components/simple/province-invest-project.vue' //简易版上市企业在本省投资
// import provinceLandProject from '@/components/simple/province-land-project.vue' //简易版企业在本省拿地投资  
import simpleEnterpriseList from '@/components/simple/total-enterprises.vue' //简易版全部内资企业  
import enterprisesCityRelationProvice from '@/components/simple/enterprisesCityRelation-province.vue' //简易版本省关系计算器  
import enterprisesComparisonTen from '@/components/simple/ten-enterprises-comparison.vue' //简易版十家企业的对比企业  

//投资大脑 研究大脑 
import regionalCompetitiveness from '@/components/touzi/regional-competitiveness.vue' //区域竞争力  
import markenterprise from '@/components/touzi/markenterprise.vue' //标杆企业投资  
import landenterprise from '@/components/touzi/landenterprise.vue' //龙头企业拿地投资  
import tzEnterpriseNews from '@/components/touzi/tzEnterpriseNews.vue' //投资动态  
import information from '@/components/touzi/information.vue' //市场情报动态  
import markingEnterpriseist from '@/components/touzi/markingEnterpriseist.vue' //对标企业  
import intelligentRecommendation from '@/components/touzi/intelligentRecommendation.vue' //龙头企业 (智能推荐页面-投资大脑专属版)  
import mapsearch from "@/components/mapsearch/enterprise-mapsearch.vue" //企业招商-地图搜索
import landMapsearch from "@/components/mapsearch/land-mapsearch.vue" //企业招商-地图搜索
import buildingMapsearch from "@/components/mapsearch/building-mapsearch.vue" //企业招商-地图搜索 
import researchIndex from "@/components/touzi/research-index.vue" //研究大脑首页
import industryLibrary from "@/components/touzi/industryLibrary.vue" //行业库、市场规模、竞争格局
import marketDetail from "@/components/detail/marketDetail.vue" //行业库、市场规模、竞争格局
import productDetail from "@/components/detail/productDetail.vue" //产品产量详情页
import industryDetail from "@/components/detail/industryDetail.vue" //行业库详情（也就是投融资底下的所有分了上市公司啥的）详情页
import trade from "@/components/touzi/trade.vue" //行业库
import tradeDetail from "@/components/detail/tradeDetail.vue" //行业库

import report from "@/components/common-list/report.vue" //研究报告，只有免登陆的免费版才有，
import reportDetail from "@/components/detail/reportDetail.vue" //研究报告，只有免登陆的免费版才有，
import bureauStatisticsDetail from "@/components/detail/bureauStatisticsDetail.vue" //统计局数据详情页，




import targetMap from "@/components/common-list/targetMap.vue" //作战地图 
import enterprisesCityRelation from "@/components/common-list/enterprisesCityRelation.vue" //企业城市关系（作战地图触达线索 ）
import industrialparkDetail from '@/components/detail/industrialparkDetail.vue' //产业园区详情页  
import policylibrary from '@/components/common-list/policylibrary.vue' //政策库 
import policylibraryN from '@/components/common-list/policylibraryN.vue' //政策库 
import reporSearch from "@/components/common-list/reporSearch.vue" // 报告搜索页



import workbenchEnterpriseDetails from '@/components/detail/workbenchEnterpriseDetails.vue' //工作台企业详情页 
//智能推荐线索------
import investmentClues1 from '@/components/recommend/investmentClues1.vue' //本省投资概率线索
import investmentClues2 from '@/components/recommend/investmentClues2.vue' //以商招商线索
import investmentClues3 from '@/components/recommend/investmentClues3.vue' //以商招商线索
import investmentClues4 from '@/components/recommend/investmentClues4.vue' //以商招商线索
import investmentClues5 from '@/components/recommend/investmentClues5.vue' //热点产业的重点企业线索 
import investmentClues6 from '@/components/recommend/investmentClues6.vue' //热点产业的重点企业线索 
import investmentClues7 from '@/components/recommend/investmentClues7.vue' //热点产业的重点企业线索 
import investmentClues8 from '@/components/recommend/investmentClues8.vue' //重点排行榜线索 
import investmentClues9 from '@/components/recommend/investmentClues9.vue' //重点榜单线索  
import siteProject from '@/components/recommend/siteProject.vue' //重点榜单线索 
import enterpriseInvestmentWindow from '@/components/recommend/enterpriseInvestmentWindow.vue' //重点榜单线索 
import industryInvestmentWindow from '@/components/recommend/industryInvestmentWindow.vue' //重点榜单线索 
import associatedEnterprise from '@/components/recommend/associated-enterprise.vue' //重点榜单线索 
// associated-enterprise-clues

//动态监测（多种投资动态）
// import information from "@/components/dynamic/information.vue" //招商情报  旧版 可废置
import investdynamic from "@/components/dynamic/invest.vue" //  投资动态
import financingdynamic from "@/components/dynamic/financing.vue" //  投资项目动态
import landdynamic from "@/components/dynamic/land.vue" //  拿地项目动态
import enterpriseNews from "@/components/dynamic/enterpriseNews.vue" //  企业资讯动态
import industryInvestment from "@/components/dynamic/industryInvestment.vue" //行业投资动态
import enterpirseinvestEdit from "@/components/dynamic/enterpriseEdit.vue" //  企业投资动态 添加关注企业
import timeforpage from "@/components/dynamic/timeinfor.vue" //  投资动态
import timeinforKey from "@/components/dynamic/informationKey.vue" //情报关键词点击
import informationdetail from "@/components/detail/informationdetail.vue" //情报资讯 详情 
//协会商会列表+详情页
import associationList from "@/components/acoctown/associationList.vue" //协会列表页
import commerceList from "@/components/acoctown/commerceList.vue" //商会列表页
import associationDetail from "@/components/acoctown/associationDetail.vue" //协会详情页
import commerceDetail from "@/components/acoctown/commerceDetail.vue" //商会详情页
import professionalTown from "@/components/acoctown/professionalTown.vue" //专业镇列表页
import professionalTownDetail from "@/components/acoctown/professionalTownDetail.vue" //专业镇详情页


//企业端口的链接
import macrobgList from '@/components/oldvue/enterprise/macro/list.vue' //宏观背景  
import pdfdetail from '@/components/oldvue/enterprise/macro/pdfdetail.vue' //宏观背景 
// import industrialList from '@/components/oldvue/enterprise/industrial/list.vue' //产业环境 
import industriallist2 from '@/components/oldvue/enterprise/industrial/list2.vue' //产业环境 -子集列表页 
import eventlian from '@/components/oldvue/enterprise/industrial/eventchain.vue' //事件/政策链  
import strategicList from '@/components/oldvue/enterprise/strategic/list.vue' //战略管理 
import newsTopics from '@/components/oldvue/enterprise/macro/topics.vue' //战略管理 
import inveprojectList from '@/components/oldvue/enterprise/project/list.vue' //投资项目 


//登录注册
import testpage from '@/components/oldvue/test.vue' //登录
// import login from '@/components/login/login.vue' //登录
import userlogin from '@/components/login/user-login.vue' //登录 
// import userLoginNew from '@/components/login/user-login-new.vue' //登录 融合投资大脑
import register from '@/components/login/register.vue' //注册
import findpassword from '@/components/login/findpassword.vue' //找回密码
import xsbUserLogin from "@/components/login/xsb-login.vue" // 湘商办登录页
//用户页面 
import govermentcenter from '@/components/user/govermentcenter.vue' //政府版中心
import baseinformation from '@/components/user/baseInformation.vue' //基础信息
// import userCollection from '@/components/user/userCollection.vue' //我的收藏
import userFocus from '@/components/user/userFocus.vue' //关注领域 
import chainNotions from '@/components/user/chainNotion.vue' //关注领域 -当地图谱引用
import userrelational from '@/components/user/userRelational.vue' //用户关系网 
import relationalcalculator from '@/components/user/relationalCalculator.vue' //关系计算器 
import calculatorresult from '@/components/user/calculatorResult.vue' //关注领域 
import servicebook from '@/components/user/serviceBook.vue' //关注领域 
import followuprecord from '@/components/user/followuprecord.vue' //跟进纪录
import todolist from '@/components/user/todolist.vue' //跟进纪录
//工作台
import projectmanagement from '@/components/user/projectmanagement.vue' //项目管理 
import statisticalAnalysis from '@/components/user/statisticalAnalysis.vue' //统计分析  
import systemManagement from '@/components/user/systemManagement.vue' //系统管理   
import workbench from '@/components/user/workbench.vue' //工作台

import editPassword from '@/components/user/editPassword.vue' //关注领域 
// import userDemand from '@/components/user/userDemand.vue' //需求供给
// ----需求供给
import demandList from '@/components/oldvue/demand/demandList.vue' //需求列表页
import demandDetail from '@/components/oldvue/demand/detail.vue' //需求详情页
import releaseDemand from '@/components/oldvue/demand/release.vue' //发布需求/供给
//管理端数字大屏
// import indexswipertest from '@/components/oldvue/indexswiper/indexswipertest.vue' //3d地图 饼图自动高标亮测试图
// import jingjizonghe from '@/components/oldvue/dataswiper/jingjizonghe.vue' //3d地图 饼图自动高标亮测试图
// import qiyeshuliang from '@/components/oldvue/dataswiper/qiyeshuliang.vue' //企业数量大屏
// import zhaoshanghuanjing2 from '@/components/oldvue/dataswiper/zhaoshanghuanjing2.vue' //招商环境大屏 
// import hongguanshuju from '@/components/oldvue/dataswiper/hongguanshuju.vue' //宏观数据大屏
// import jingzhengli from '@/components/oldvue/dataswiper/jingzhengli.vue' //竞争力大屏
// import chanyeyongdi from '@/components/oldvue/dataswiper/chanyeyongdi.vue' //产业用地大屏
// import zhaoshangditu from '@/components/oldvue/dataswiper/zhaoshangditu.vue' //产业用地大屏
// import longtouqiye from '@/components/oldvue/dataswiper/longtouqiye.vue' //龙头企业大屏
// import qiyeshuju from '@/components/oldvue/dataswiper/qiyeshuju.vue' //企业数据大屏
// import zhaoshangxiangmu from '@/components/oldvue/dataswiper/zhaoshangxiangmu.vue' //招商项目大屏
// import chanyefenbu from '@/components/oldvue/dataswiper/chanyefenbu.vue' //产业分布大屏
// import maptest from '@/components/oldvue/dataswiper/maptest.vue' //地图测试
// import chanyefazhan from '@/components/oldvue/dataswiper/chanyefazhan.vue' //产业发展数字大屏 

//业务端数字大屏
import zhudaochanyelian from '@/components/oldvue/business/zhudaochanyelian.vue' //产业发展数字大屏 
import zhaoshangtupu from '@/components/oldvue/business/zhaoshangtupu.vue' //产业发展数字大屏 
import quxianzonghe from '@/components/oldvue/business/quxianzonghe.vue' //各区县综合大屏
import quxianzhaoshang from '@/components/oldvue/business/quxianzhaoshang.vue' //各区县招商大屏

//数字大屏sass通用版
import hongguanshuju1 from '@/components/dataswiper-sass/hongguanshuju.vue' //宏观数据
import jingzhengli1 from '@/components/dataswiper-sass/jingzhengli.vue' //竞争力
import zhaoshangditu1 from '@/components/dataswiper-sass/zhaoshangditu.vue' //招商地图
import zhaoshanghuanjing1 from '@/components/dataswiper-sass/zhaoshanghuanjing.vue' //招商环境
import zhaoshangxiangmu1 from '@/components/dataswiper-sass/zhaoshangxiangmu.vue' //招商项目
import chanyefazhan1 from '@/components/dataswiper-sass/chanyefazhan.vue' //产业发展
import chanyeyongdi1 from '@/components/dataswiper-sass/chanyeyongdi.vue' //产业用地
import qiyeshuju1 from '@/components/dataswiper-sass/qiyeshuju.vue' //企业数据统计
import zhaoshangtupu1 from '@/components/dataswiper-sass/zhaoshangtupu.vue' //招商图谱
import dangdijingjifazhan from '@/components/dataswiper-sass/dangdijingjifazhan.vue' //招商图谱




//-----------------
import testvuetour from '@/components/vuetourTest.vue' //测试用户指引导航
import HelloWorld from '@/components/oldvue/HelloWorld.vue'
import competitive from '@/components/oldvue/competitive.vue'
import strategy from '@/components/oldvue/strategy.vue'
import investmentdata from '@/components/oldvue/investmentdata.vue'
import qualityenterprise1 from "@/components/old/qualityenterprise1.vue" //目标企业（龙头企业）
import qualityenterprise9 from "@/components/old/qualityenterprise9.vue" //目标企业（上市企业）
import qualityenterprise2 from "@/components/old/qualityenterprise2.vue" //目标企业（创新企业）
import qualityenterprise3 from "@/components/old/qualityenterprise3.vue" //目标企业（优质企业）
import allsearch from '@/components/old/allsearch.vue' //搜索企业全库 
import localenterprise from '@/components/old/localKeyEnterprise.vue' //本地重点企业 已搁置
import innovativeEnterprise from '@/components/old/innovativeEnterprise.vue' //创新企业（小企业）
import search from "@/components/old/search.vue" //搜索页 已搁置 
import focuseprak from '@/components/old/focuseprak.vue' //关注园区 //已废止
import localchainlistold from '@/components/old/localChainlist.vue' //当地图谱产业链（所有产业链 ） //已改名停止
import testmap from '@/components/old/testmap.vue' //产业机会(全国图谱)s旧版
import investmentCluesIpo from '@/components/old/investmentCluesIpo.vue' //热点产业的重点企业线索  暂停使用
import investmentCluesIpocity from '@/components/old/investmentCluesIpocity.vue' //热点产业的重点企业线索 暂停使用
import enterpriseInvestdynamic from "@/components/old/enterpriseInvest.vue" //  企业投资动态 暂停使用
Vue.use(Router)

const router = new Router({
	// mode: "history",
	mode: "hash",
	routes: [{
		path: '/leftnav',
		name: 'leftnav',
		component: leftnav
	},
	{
		path: '/HelloWorld',
		name: 'HelloWorld',
		component: HelloWorld
	},
	{
		path: '/testvuetour',
		name: 'testvuetour',
		component: testvuetour
	},
	//招商大脑简易版
	{

		path: '/video-courses',
		name: 'videoCourses',
		component: videoCourses
	},
	{
		path: '/invest-project-trend',
		name: 'cityInvestTrend',
		component: cityInvestTrend
	},
	{
		path: '/simple-enterprise-list',
		name: 'simpleEnterpriseList',
		component: simpleEnterpriseList
	},
	{
		path: '/enterprisesCityRelation-province',
		name: 'enterprisesCityRelationProvice',
		component: enterprisesCityRelationProvice
	},
	{
		path: '/tenEnterprisesComparison',
		name: 'TenEnterprisesComparison',
		component: enterprisesComparisonTen
	},
	//园区招商大脑
	{
		path: '/allBuildings',
		name: 'allBuildings',
		component: allBuildings
	},
	{
		path: '/building',
		name: 'building',
		component: buildingdetail
	},
	{
		path: '/allEnterprises',
		name: 'allEnterprises',
		component: allenterprise
	},
	{
		path: '/enterpriseYq',
		name: 'enterpriseYq',
		component: enterpriseYq
	},
	{
		path: '/parkFocusEnterprises',
		name: 'parkFocusEnterprises',
		component: parkFocusEnterprises
	},
	//投资大脑 研究大脑 
	{
		path: '/regional-competitiveness',
		name: 'regionalCompetitiveness',
		component: regionalCompetitiveness
	},
	{
		path: '/markenterprise',
		name: 'markenterprise',
		component: markenterprise
	},
	{
		path: '/landenterprise',
		name: 'landenterprise',
		component: landenterprise
	},
	{
		path: '/tzEnterpriseNews',
		name: 'tzEnterpriseNews',
		component: tzEnterpriseNews
	},
	{
		path: '/information',
		name: 'information',
		component: information
	},
	{
		path: '/markingEnterpriseist',
		name: 'markingEnterpriseist',
		component: markingEnterpriseist
	},
	{
		path: '/intelligentRecommendation',
		name: 'intelligentRecommendation',
		component: intelligentRecommendation
	},
	{
		path: '/researchIndex',
		name: 'researchIndex',
		component: researchIndex
	},
	{
		path: '/industryLibrary',
		name: 'industryLibrary',
		component: industryLibrary
	},
	{
		path: '/trade',
		name: 'trade',
		component: trade
	},
	{
		path: '/tradeDetail',
		name: 'tradeDetail',
		component: tradeDetail
	},
	
	{
		path: '/marketDetail',
		name: 'marketDetail',
		component: marketDetail
	},
	{
		path: '/productDetail',
		name: 'productDetail',
		component: productDetail
	},
	{
		path: '/industryDetail',
		name: 'industryDetail',
		component: industryDetail
	},
	
	{
		path: '/report',
		name: 'report',
		component: report
	},
	{
		path: '/reportDetail',
		name: 'reportDetail',
		component: reportDetail
	},
	{
		path: '/bureauStatisticsDetail',
		name: 'bureauStatisticsDetail',
		component: bureauStatisticsDetail
	},
	{
		path: '/reporSearch',
		name: 'reporSearch',
		component: reporSearch
	},
	
	//首页 
	{
		path: '/',
		name: 'userlogin',
		component: userlogin,
		// redirect:"/enterpriseList"
	},
	{
		path: '/xsb-login',
		name: 'xsbUserLogin',
		component: xsbUserLogin
	},
	
	{
		path: '/home',
		name: 'index',
		component: indexpage
	},
	
	// {
	// 	path: '/echarttest',
	// 	name: 'indexswipertest',
	// 	component: indexswipertest
	// },
	// {
	// 	path: '/jingjizonghe',
	// 	name: 'jingjizonghe',
	// 	component: jingjizonghe
	// },
	// {
	// 	path: '/qiyeshuliang',
	// 	name: 'qiyeshuliang',
	// 	component: qiyeshuliang
	// },
	// {
	// 	path: '/zhaoshanghuanjing2',
	// 	name: 'zhaoshanghuanjing2',
	// 	component: zhaoshanghuanjing2
	// },
	// {
	// 	path: '/hongguanshuju',
	// 	name: 'hongguanshuju',
	// 	component: hongguanshuju
	// },
	// {
	// 	path: '/jingzhengli',
	// 	name: 'jingzhengli',
	// 	component: jingzhengli
	// },
	// {
	// 	path: '/chanyeyongdi',
	// 	name: 'chanyeyongdi',
	// 	component: chanyeyongdi
	// },
	// {
	// 	path: '/zhaoshangditu',
	// 	name: 'zhaoshangditu',
	// 	component: zhaoshangditu
	// },
	// {
	// 	path: '/longtouqiye',
	// 	name: 'longtouqiye',
	// 	component: longtouqiye
	// },

	// {
	// 	path: '/qiyeshuju',
	// 	name: 'qiyeshuju',
	// 	component: qiyeshuju
	// },
	// {
	// 	path: '/zhaoshangxiangmu',
	// 	name: 'zhaoshangxiangmu',
	// 	component: zhaoshangxiangmu
	// },
	// {
	// 	path: '/chanyefenbu',
	// 	name: 'chanyefenbu',
	// 	component: chanyefenbu
	// },
	// {
	// 	path: '/chanyefazhan',
	// 	name: 'chanyefazhan',
	// 	component: chanyefazhan
	// },
	// {
	// 	path: '/maptest',
	// 	name: 'maptest',
	// 	component: maptest
	// },
	{
		path: '/zhudaochanyelian',
		name: 'zhudaochanyelian',
		component: zhudaochanyelian
	},
	{
		path: '/zhaoshangtupu',
		name: 'zhaoshangtupu',
		component: zhaoshangtupu
	},
	{
		path: '/quxianzonghe',
		name: 'quxianzonghe',
		component: quxianzonghe
	},
	{
		path: '/quxianzhaoshang',
		name: 'quxianzhaoshang',
		component: quxianzhaoshang
	},
	//数字大屏saas版 
	{
		path: '/hongguanshuju-saas',
		name: 'hongguanshuju1',
		component: hongguanshuju1
	},
	{
		path: '/jingzhengli-saas',
		name: 'jingzhengli1',
		component: jingzhengli1
	},
	{
		path: '/zhaoshangditu-saas',
		name: 'zhaoshangditu1',
		component: zhaoshangditu1
	},
	{
		path: '/zhaoshanghuanjing2-saas',
		name: 'zhaoshanghuanjing1',
		component: zhaoshanghuanjing1
	},
	{
		path: '/zhaoshangxiangmu-saas',
		name: 'zhaoshangxiangmu1',
		component: zhaoshangxiangmu1
	},
	{
		path: '/chanyefazhan-saas',
		name: 'chanyefazhan1',
		component: chanyefazhan1
	},
	{
		path: '/chanyeyongdi-saas',
		name: 'chanyeyongdi1',
		component: chanyeyongdi1
	},
	{
		path: '/qiyeshuju-saas',
		name: 'qiyeshuju1',
		component: qiyeshuju1
	},
	{
		path: '/zhaoshangtupu-saas',
		name: 'zhaoshangtupu1',
		component: zhaoshangtupu1
	},
	{
		path: '/dangdijingjifazhan-saas',
		name: 'dangdijingjifazhan',
		component: dangdijingjifazhan
	},
	{
		path: '/homex',
		name: 'indexlist',
		component: indexlist
	},
	{
		path: '/testpage',
		name: 'testpage',
		component: testpage
	},
	//政府端
	{
		path: '/localKeyEnterprises',
		name: 'localKeyEnterprises',
		component: localenterprise
	},
	{
		path: '/industrial-opportunities',
		name: 'industrial-opportunities',
		component: opportunities
	},
	{
		path: '/concerned-enterprises',
		name: 'concerned-enterprises',
		component: concernedEn,
	},
	{
		path: '/recommendation',
		name: 'recommendation',
		component: recommendation,
	},
	{
		path: '/innovative-enterprises',
		name: 'innovative-enterprise',
		component: innovativeEnterprise,
	},
	{
		path: '/innovative-resources',
		name: 'innovativeResources',
		component: innovativeResources,
	},
	{
		path: '/investment-institutions',
		name: 'investmentInstitutions',
		component: investmentInstitutions,
	},

	{
		path: "/chain",
		name: "chaindetail",
		component: chaindetailpage,
	},
	{
		path: "/localChain",
		name: "localChaindetail",
		component: localChaindetail,
	},
	// {
	// 	path: "/enterprise-compare",
	// 	name: "enterpriseCompare",
	// 	component: enterpriseCompare,
	// },
	
	{
		path: "/policy-compare",
		name: "policyCompareTable",
		component: policyCompareTable,
	},
	{
		path: "/enterprise-compare",
		name: "enterpriseCompareTable",
		component: enterpriseCompareTable,
	},
	{
		path: "/enterprise-compare-records",
		name: "enterpriseCompareRecords",
		component: enterpriseCompareRecords,
	},

	{
		path: "/localChainMoreEnterprise",
		name: "localChainMoreEnterprise",
		component: localChainMoreEnterprise,
	},
	{
		path: "/generateCharts",
		name: "generateCharts",
		component: generateCharts,
	},
	{
		path: "/chartDetail",
		name: "chartDetail",
		component: chartDetail,
	},
	{
		path: '/enterprises',
		name: 'enterprise_detail',
		component: enterpriseDetail
	},
	{
		path: '/enterprises-free',
		name: 'enterprise_detail_free',
		component: enterpriseDetailFree
	},
	{
		path: '/enterpriseSurroundMap',
		name: 'enterpriseSurroundMap',
		component: enterpriseSurroundMap
	},
	{
		path: '/localInvestAnalysis',
		name: 'localInvestAnalysis',
		component: localInvestAnalysis
	},
	{
		path: '/investEnterpirseDetail',
		name: 'investAnalysisEnterpirseDetail',
		component: investAnalysisEnterpirseDetail
	},
	{
		path: '/foreignInvestment',
		name: 'foreignInvestment',
		component: foreignInvestment
	},
	{
		path: '/free-tips',
		name: 'freeTips',
		component: freeTips
	},
	{
		path: '/wx-pay',
		name: 'wxPay',
		component: wxPay
	},
	{
		path: '/aiChat',
		name: 'aiChat',
		component: aiChat
	},
	
	{
		path: '/paySuccess',
		name: 'paySuccess',
		component: paySuccess
	},
	{
		path: '/payType',
		name: 'payType',
		component: payType
	},
	{
		path: '/orders',
		name: 'orders',
		component: orders
	},
	{
		path: '/homePage',
		name: 'homePage',
		component: homePage
	},
	
	{
		path: '/enterprisesF',
		name: 'enterprise_detail_f',
		component: enterpriseDetailF
	},
	// {
	// 	path: '/enterprises',
	// 	name: 'enterprise_detail',
	// 	component: enterpriseDetail
	// },
	{
		path: '/resources-enterprises',
		name: 'inresourcesDetail',
		component: inresourcesDetail
	},
	{
		path: '/investement-enterprises',
		name: 'institutionDetail',
		component: institutionDetail
	},

	{
		path: '/enterpriseTag',
		name: 'enterpriseTag',
		component: tagsearch,
	},
	{
		path: '/targetEnterprise',
		name: 'targetEnterprise',
		component: targetEnterprise,
	},
	{
		path: '/search',
		name: 'search',
		component: search,
	},
	{
		path: '/qualityenterprise1',
		name: 'qualityenterprise1',
		component: qualityenterprise1,
	},
	{
		path: '/qualityenterprise9',
		name: 'qualityenterprise9',
		component: qualityenterprise9
	},
	{
		path: '/enterpriseList',
		name: 'enterpriseList',
		component: enterpriseList,
	},

	{
		path: '/forcapEnterprise',
		name: 'forcapEnterprise',
		component: forcapEnterprise,
	},
	{
		path: '/foreignEnterprises',
		name: 'ForeignEnterprises',
		component: ForeignEnterprises,
	},
	{
		path: '/totalEnterprises',
		name: 'totalenterprises',
		component: totalenterprises,
	},
	{
		path: '/totalSearch',
		name: 'totalSearch',
		component: totalSearch,
	},

	{
		path: '/localChainList',
		name: 'localChainList',
		component: localChainList,
	},
	{
		path: '/chainEnterpriselist',
		name: 'chainEnterpriselist',
		component: chainEnterpriselist,
	},
	{
		path: '/qualityenterprise2',
		name: 'qualityenterprise2',
		component: qualityenterprise2,
	},
	{
		path: '/qualityenterprise3',
		name: 'qualityenterprise3',
		component: qualityenterprise3,
	},
	{
		path: '/enterprise-mapsearch',
		name: 'enterprisemapsearch',
		component: mapsearch,
	},
	{
		path: '/land-mapsearch',
		name: 'landmapsearch',
		component: landMapsearch,
	},
	{
		path: '/building-mapsearch',
		name: 'buildingmapsearch',
		component: buildingMapsearch,
	},


	{
		path: '/industrialpark',
		name: 'industrialpark',
		component: industrialpark,
	},
	{
		path: '/industrialparkDetail',
		name: 'industrialparkDetail',
		component: industrialparkDetail,
	},

	{
		path: '/targetMap',
		name: 'targetMap',
		component: targetMap,
	},
	{
		path: '/enterprisesCityRelation',
		name: 'enterprisesCityRelation',
		component: enterprisesCityRelation,
	},
	{
		path: '/focusenterprises',
		name: 'focusenterprises',
		component: focusenterprises,
	},
	{
		path: '/focuseprak',
		name: 'focuseprak',
		component: focuseprak,
	},
	{
		path: '/policylibrary',
		name: 'policylibrary',
		component: policylibrary,
	},
	{
		path: '/policylibrary-N',
		name: 'policylibraryN',
		component: policylibraryN,
	},
	
	{
		path: '/projectmanagement',
		name: 'projectmanagement',
		component: projectmanagement,
	},
	{
		path: '/todolist',
		name: 'todolist',
		component: todolist,
	},
	{
		path: '/followuprecord',
		name: 'followuprecord',
		component: followuprecord,
	},
	{
		path: '/statisticalAnalysis',
		name: 'statisticalAnalysis',
		component: statisticalAnalysis,
	},
	{
		path: '/systemManagement',
		name: 'systemManagement',
		component: systemManagement,
	},
	{
		path: '/workbench',
		name: 'workbench',
		component: workbench,
	},
	{
		path: '/workbenchEnterpriseDetails',
		name: 'workbenchEnterpriseDetails',
		component: workbenchEnterpriseDetails,
	},
	{
		path: '/associationList',
		name: 'associationList',
		component: associationList,
	},
	{
		path: '/commerceList',
		name: 'commerceList',
		component: commerceList,
	},
	{
		path: '/associationDetail',
		name: 'associationDetail',
		component: associationDetail,
	},
	{
		path: '/commerceDetail',
		name: 'commerceDetail',
		component: commerceDetail,
	},
	{
		path: '/professionalTown',
		name: 'professionalTown',
		component: professionalTown,
	},
	{
		path: '/professionalTownDetail',
		name: 'professionalTownDetail',
		component: professionalTownDetail,
	},
	{
		name: "investdynamic",
		path: "/investdynamic",
		component: investdynamic
	},
	{
		name: "financingdynamic",
		path: "/financingdynamic",
		component: financingdynamic
	},
	{
		name: "enterpriseNews",
		path: "/enterpriseNews",
		component: enterpriseNews
	},
	{
		name: "landdynamic",
		path: "/landdynamic",
		component: landdynamic
	},
	{
		name: "industryInvestment",
		path: "/industryInvestment",
		component: industryInvestment
	},
	// {
	// 	name: "enterpriseInvestdynamic",
	// 	path: "/enterpriseInvestdynamic",
	// 	component: enterpriseInvestdynamic
	// },
	{
		name: "enterpirseinvestEdit",
		path: "/enterpirseinvestEdit",
		component: enterpirseinvestEdit
	},
	{
		name: "timeinfor",
		path: "/timeinfor",
		component: timeforpage
	},
	{
		name: "timeinforKey",
		path: "/timeinforKey",
		component: timeinforKey
	},
	// {
	//   path: '/information',
	//   name: 'information',
	//   component: information, 
	// },	

	{
		path: '/informationdetail',
		name: 'informationdetail',
		component: informationdetail,
	},
	{
		path: '/investment-clues1',
		name: 'investmentClues1',
		component: investmentClues1,
	},
	{
		path: '/investment-clues2',
		name: 'investmentClues2',
		component: investmentClues2,
	},
	{
		path: '/investment-clues3',
		name: 'investmentClues3',
		component: investmentClues3,
	},
	{
		path: '/investment-clues4',
		name: 'investmentClues4',
		component: investmentClues4,
	},
	{
		path: '/investment-clues5',
		name: 'investmentClues5',
		component: investmentClues5,
	},
	{
		path: '/investment-clues6',
		name: 'investmentClues6',
		component: investmentClues6,
	},
	{
		path: '/investment-clues7',
		name: 'investmentClues7',
		component: investmentClues7,
	},
	{
		path: '/investment-clues8',
		name: 'investmentClues8',
		component: investmentClues8,
	},
	{
		path: '/investment-clues9',
		name: 'investmentClues9',
		component: investmentClues9,
	},
	{
		path: '/enterpriseInvestmentWindow',
		name: 'enterpriseInvestmentWindow',
		component: enterpriseInvestmentWindow,
	},
	{
		path: '/associated-enterprise-clues',
		name: 'associatedEnterprise',
		component: associatedEnterprise,
	},
	{
		path: '/siteProject',
		name: 'siteProject',
		component: siteProject,
	},

	{
		path: '/industryInvestmentWindow',
		name: 'industryInvestmentWindow',
		component: industryInvestmentWindow,
	},

	// {
	//   path: '/investmentClues9',
	//   name: 'investmentCluesIpo',
	//   component: investmentCluesIpo, 
	// },
	// {
	//   path: '/investmentClues10',
	//   name: 'investmentCluesIpocity',
	//   component: investmentCluesIpocity, 
	// },
	{
		path: '/allsearch',
		name: 'allsearch',
		component: allsearch,
	},

	{
		path: '/allchain',
		name: 'allchain',
		component: allchain,
	},
	// {
	// 	path: '/localchainlist',
	// 	name: 'localchainlist',
	// 	component: localchainlist,
	// },
	{
		path: '/urbanBigDataList',
		name: 'urbanBigDataList',
		component: urbanBigDataList,
	},
	{
		path: '/urbanBigData',
		name: 'urbanBigData',
		component: urbanBigData,
	},
	//用户中心-我的页面
	{
		path: '/govermentcenter',
		name: 'govermentcenter',
		component: govermentcenter
	},
	{
		path: '/baseinformation',
		name: 'baseinformation',
		component: baseinformation
	},
	{
		path: '/servicebook',
		name: 'servicebook',
		component: servicebook
	},
	{
		path: '/userFocus',
		name: 'userFocus',
		component: userFocus
	},
	{
		path: '/chainNotions',
		name: 'chainNotions',
		component: chainNotions
	},
	{
		path: '/userrelational',
		name: 'userrelational',
		component: userrelational
	},
	{
		path: '/relationalcalculator',
		name: 'relationalcalculator',
		component: relationalcalculator
	},
	{
		path: '/calculatorresult',
		name: 'calculatorresult',
		component: calculatorresult
	},
	{
		path: '/editPassword',
		name: 'editPassword',
		component: editPassword
	},
	// {
	// 	path: '/userCollection',
	// 	name: 'userCollection',
	// 	component: userCollection
	// },
	// {
	// 	path: '/userDemand',
	// 	name: 'userdemandList',
	// 	component: userDemand
	// },
	//企业端
	{
		path: '/macro-background',
		name: 'macrobgList',
		component: macrobgList
	},
	{
		path: '/news',
		name: 'newsdetail',
		component: newsdetail
	},
	{
		path: '/pdf',
		name: 'pdfdetail',
		component: pdfdetail
	},
	// {
	// 	path: '/industrial-environment',
	// 	name: 'industrialList',
	// 	component: industrialList
	// },
	{
		path: '/industrial-list',
		name: 'industriallist2',
		component: industriallist2
	},
	{
		path: '/eventChain',
		name: 'eventlian',
		component: eventlian
	},
	{
		path: '/strategic',
		name: 'strategicList',
		component: strategicList
	},
	{
		path: '/newsTopics',
		name: 'newsTopics',
		component: newsTopics
	},
	{
		path: '/investment-project',
		name: 'inveprojectList',
		component: inveprojectList
	},
	//废弃闲置
	{
		path: '/competitive-position',
		name: 'competitive-position',
		component: competitive
	},
	{
		path: '/strategy-policy',
		name: 'strategy-policy',
		component: strategy
	},
	// {
	//   path: '/investmentdata',
	//   name: 'investmentdata',
	//   component: investmentdata
	// }, 

	//登录注册找回密码
	// {
	// 	path: '/login',
	// 	name: 'userlogin',
	// 	component: userlogin
	// },
	{
		path: '/user-login',
		name: 'user-login',
		component: userlogin
	},
	{
		path: '/register',
		name: 'registerPage',
		component: register
	},
	{
		path: '/findpassword',
		name: 'findPassword',
		component: findpassword
	},
	{
		path: '/demandlist',
		name: "demandList",
		component: demandList
	},
	{
		path: '/demandRelease',
		name: "releasePage",
		component: releaseDemand
	},
	{
		path: '/demand',
		name: "demandDetail",
		component: demandDetail
	},


		// {
		//   path: '/chainDetail',
		//   name: 'chaindetail',
		//   component: chaindetail
		// }, 
	]
})

var clasnum = 1;
router.beforeEach((to, from, next) => {
	// chrome
	document.body.scrollTop = 0
	// firefox
	document.documentElement.scrollTop = 0
	// safari
	window.pageYOffset = 0
	next()
});


// const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// };
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
	console.log(to.path,'-----',from.path,'-----',next.path);
	// if (to.path === '/login' || to.path === '/register' || to.path === '/findpassword' || to.path === '/user-login' || to.path === '/video-courses') {
	// 	console.log('to.path', to.path)
	// 	next();
	// } else {
	// 	//非跳转到登录界面时，判断本地存储userData是否为null或空，为空则跳回到登录界面，反之到相应的界面(此时有数据)。
	// 	// console.log(localStorage.getItem('userData'))
	// 	let userData = JSON.parse(localStorage.getItem('userData'));
	// 	let userData1 = JSON.parse(sessionStorage.getItem('userData'))
	// 	let onwuserdata = userData ? userData : userData1;
	// 	clasnum++;
	// 	console.log('router',onwuserdata);
	// 	// console.log(clasnum);
	// 	// if(clasnum<3){ 
	// 	if (onwuserdata === null || onwuserdata === '') {
	// 		// window.location.href = api.getLoginUrl();
			
	// 		next('/user-login');
	// 	} else {
			next();
	// 	}
	// 	// }else{
	// 	// 	return;
	// 	// } 
	// }
});
export default router;
